import Vue from 'vue'
import VueRouter from 'vue-router'

import company from '$modules/company/routes'
// import membership from '$modules/membership/routes'
import person from '$modules/person/routes'
import event from '$modules/event/routes'
import contract from '$modules/contract/routes'
import user from '$modules/user/routes'
import file from '$modules/file/routes'
import address from '$modules/address/routes'
// import state from '$modules/state/routes'
// import country from '$modules/country/routes'
import purchase from '$modules/purchase/routes'

/** * MODULE ROUTES ***/
const moduleRoutes = [company, person, user, event, contract, file, purchase, address].reduce((arr, m) => arr.concat(m), [])

/** * AUTH ROUTES ***/
const authRoutes = [
  {
    path: '/auth',
    redirect: '/auth/login',
    meta: {
      auth: [],
      title: 'Login',
      hidden: true
    },
    component: () => import('layouts/auth'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('pages/auth/login'),
        meta: {
          auth: [],
          title: 'Login',
          hidden: true
        }
      },
      {
        path: 'forgot',
        name: 'forgot',
        component: () => import('pages/auth/forgot'),
        meta: {
          auth: [],
          title: 'Forgot',
          hidden: true
        }
      },
      {
        path: 'reset',
        name: 'reset',
        component: () => import('pages/auth/reset'),
        meta: {
          auth: [],
          title: 'Reset',
          hidden: true
        }
      }
    ]
  }
]

const legalRoutes = [
  {
    path: '/legal',
    redirect: '/legal',
    meta: {
      auth: [],
      title: 'Legal',
      hidden: true
    },
    component: () => import('layouts/auth'),
    children: [
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        component: () => import('pages/legal/privacy-policy'),
        meta: {
          auth: [],
          title: 'Privacy Policy',
          hidden: true
        }
      },
      {
        path: 'end-user-license',
        name: 'end-user-license',
        component: () => import('pages/legal/end-user-license'),
        meta: {
          auth: [],
          title: 'End User License Agreement',
          hidden: true
        }
      }
    ]
  }
]

const pendingApprovalRoutes = [
  {
    path: '/pending-approval',
    meta: {
      title: 'Pending Approval',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'check_box'
    },
    component: () => import('pages/admin/pending_approval/index')
    // redirect: 'pending-approval/new',
    // children: [
    //   {
    //     path: 'new',
    //     meta: {
    //       auth: ['Admin', 'Super Admin'],
    //       title: 'New Registrations',
    //       icon: 'new_releases',
    //       hidden: false
    //     },
    //     component: () => import('pages/admin/pending_approval/new')
    //   },
    //   {
    //     path: 'changes',
    //     meta: {
    //       auth: ['Admin', 'Super Admin'],
    //       title: 'User Changes',
    //       icon: 'edit',
    //       hidden: false
    //     },
    //     component: () => import('pages/admin/pending_approval/changes')
    //   }
    // ]
  }
]

const quickbooksRoutes = [
  {
    path: '/quickbooks',
    meta: {
      title: 'Quickbooks',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'account_balance'
    },
    // component: () => import('pages/admin/quickbooks/connect'),
    // component: () => import('layouts/default'),
    component: () => import('pages/admin/quickbooks/index')
    // redirect: 'quickbooks/connect',
    // children: [
    //   {
    //     path: 'connect',
    //     meta: {
    //       auth: ['Admin', 'Super Admin'],
    //       title: 'Quickbooks Connect',
    //       icon: 'cast_connected',
    //       hidden: false
    //     },
    //     component: () => import('pages/admin/quickbooks/connect')
    //   },
    //   {
    //     path: 'help',
    //     meta: {
    //       auth: ['Admin', 'Super Admin'],
    //       title: 'Quickbooks Help',
    //       icon: 'help',
    //       hidden: false
    //     },
    //     component: () => import('pages/admin/quickbooks/help')
    //   }
    // ]
  }
]

Vue.use(VueRouter)

/** * ADMIN ROUTES ***/
export const adminRoutes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Dashboard',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'dashboard'
    },
    component: () => import('pages/admin/index.vue')
  }
  // {
  //   path: '/admin',
  //   name: 'home',
  //   meta: {
  //     title: 'Dashboard',
  //     auth: ['Admin', 'Super Admin'],
  //     hidden: false,
  //     icon: 'dashboard'
  //   },
  //   component: () => import('pages/admin/index.vue')
  // }
].concat(pendingApprovalRoutes, moduleRoutes, quickbooksRoutes)

// console.log(adminRoutes)

const routes = [
  {
    path: '/',
    component: () => import('layouts/default.vue'),
    meta: { auth: ['Super Admin', 'Admin'] },
    children: adminRoutes
  }
].concat(authRoutes, legalRoutes)

routes.push({
  // Always leave this as last one
  path: '*',
  component: () => import('pages/404')
})

const Router = new VueRouter({
  /*
   * NOTE! Change Vue Router mode from quasar.conf.js -> build -> vueRouterMode
   *
   * When going with "history" mode, please also make sure "build.publicPath"
   * is set to something other than an empty string.
   * Example: '/' instead of ''
   */

  // Leave as is and change from quasar.conf.js instead!
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// console.log(routes)

export default Router
